"use client";
import React, { useState, useEffect } from "react";
import { Table, Space, Button, message, Spin } from "antd";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { useDispatch, useSelector } from "react-redux";
import { fetchFile } from "../../../../redux/action/fetchAction";
import Filter from "./Filter";
import {
  FETCH_DATA_NOTIFIED,
  FETCH_DATA_RESET,
  NEW_REPORT_FILE_NOTIFIED,
  NEW_REPORT_FILE_RESET,
} from "../../../../redux/action/actionType";
import { newReportFile } from "../../../../redux/action/newReport";
// Columns configuration
const columns = [
  { title: "Name", dataIndex: "name" },
  { title: "From Time", dataIndex: "fromTime" },
  { title: "To Time", dataIndex: "toTime" },
  { title: "Duration In Hrs.", dataIndex: "duration" },
];

const DevelopmentTable = () => {
  const dispatch = useDispatch();
  const { fetchData } = useSelector((state) => {
    return {
      fetchData: state.fetch,
    };
  });

  const { newReport } = useSelector((state) => {
    return {
      newReport: state?.newReportReducer,
    };
  });

  const [data, setData] = useState([]);
  const [selectedFile, setSelectedFile] = useState({
    cycleNo: null,
    fileType: null,
    billerId: null,
    // date: new Date().toISOString(),
    date: null,
  });
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (
      selectedFile.cycleNo !== null &&
      selectedFile.date !== null &&
      selectedFile.fileType !== null
    ) {
      // dispatch(fetchFile(selectedFile));
      dispatch(newReportFile(selectedFile));
    }
  }, [selectedFile, dispatch]);

  useEffect(() => {
    if (newReport?.data) {
      const tableData = newReport?.data?.url?.map((file, index) => ({
        name: `Transaction-${index + 1}`,
        fromTime: "N/A",
        toTime: "N/A",
        duration: "N/A",
        date: file?.date || "N/A",
        fileUrl: file,
      }));
      setData(tableData);
    } else {
      setData(null);
    }
  }, [newReport?.data]);

  const rowSelection = {
    onChange: (_, selectedRows) => setSelectedRows(selectedRows),
  };

  // function to update toast notification based on state
  useEffect(() => {
    if (fetch?.loading === true) {
      message.destroy();
      message.loading({
        content: "Fetching....",
      });
    } else if (
      newReport?.loading === false &&
      newReport?.data?.message?.length > 0 &&
      newReport?.data?.url?.length === 0 &&
      newReport?.error === null
    ) {
      message.destroy();
      message
        .info({
          content: "No transaction data available",
          duration: 2,
        })
        .then(() =>
          dispatch({
            type: NEW_REPORT_FILE_RESET,
          })
        );
    } else if (newReport?.loading === false && newReport?.error !== null) {
      message.destroy();
      message
        .error({
          content:
            newReport?.error?.response?.data?.message ||
            newReport?.error?.message ||
            newReport?.error,
          duration: 2,
        })
        .then(() =>
          dispatch({
            type: NEW_REPORT_FILE_RESET,
          })
        );
    } else if (
      newReport?.loading === false &&
      newReport?.data?.url?.length > 0 &&
      newReport?.notified === false
    ) {
      message.destroy();
      message
        .success({
          content: newReport?.data?.message || "Data fetched successfully!",
          duration: 2,
        })
        .then(() =>
          dispatch({
            type: NEW_REPORT_FILE_NOTIFIED,
          })
        );
    }
  }, [newReport]);

  // Handle Single File Download with Proxy
  const handleDownload = async (fileUrl) => {
    try {
      // Fetch the file content
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error(`Failed to fetch the file. Status: ${response.status}`);
      }

      // Convert response to blob
      const blob = await response.blob();

      if (blob.size === 0) {
        throw new Error("Received empty file.");
      }

      // Create a temporary URL for the blob
      const downloadUrl = window.URL.createObjectURL(blob);

      // Extract the file name or use a default name
      const fileName = fileUrl.split("/").pop() || "downloaded-file.json";

      // Create an anchor element and simulate a click
      const anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = fileName;
      document.body.appendChild(anchor); // Attach to the DOM
      anchor.click(); // Trigger the download
      document.body.removeChild(anchor); // Clean up the DOM

      // Revoke the object URL
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Download failed:", error.message);
    }
  };

  // Handle Multiple File Download as ZIP
  const handleDownloadZip = async () => {
    try {
      const zip = new JSZip();
      const zipFolder = zip.folder("files");

      for (const row of selectedRows) {
        const fileUrl = row.fileUrl;
        const fileName = fileUrl.split("/").pop();

        // Proxy the request through a backend endpoint
        const proxyUrl = `/api/proxy?url=${encodeURIComponent(fileUrl)}`;
        const response = await fetch(proxyUrl);
        if (!response.ok) {
          console.warn(`Failed to fetch ${fileUrl} through proxy`);
          continue; // Skip this file if it can't be fetched
        }

        const fileBlob = await response.blob();
        zipFolder.file(fileName, fileBlob);
      }

      const zipContent = await zip.generateAsync({ type: "blob" });
      saveAs(zipContent, "files.zip");
    } catch (error) {
      console.error("ZIP download failed:", error);
    }
  };

  return (
    <div>
      <Space className="mb-4 flex w-full justify-between">
        <Filter selectedFile={selectedFile} setSelectedFile={setSelectedFile} />
        <Button
          type="primary"
          onClick={handleDownloadZip}
          disabled={selectedRows?.length === 0}
        >
          Download All as Zip
        </Button>
      </Space>

      <Table
        columns={[
          ...columns,
          {
            title: "Actions",
            render: (_, record) => (
              <Space>
                <a
                  // href={record.fileUrl}
                  // download={true}
                  onClick={() => handleDownload(record.fileUrl)}
                  style={{ cursor: "pointer", color: "blue" }}
                >
                  Download File
                </a>
              </Space>
            ),
          },
        ]}
        rowKey={(record) => record?.name}
        dataSource={data}
        loading={newReport?.loading}
        rowSelection={rowSelection}
      />
    </div>
  );
};

export default DevelopmentTable;
